// Documentary photographs only. Campaign imagery never enters this gallery.
import {catalogueImageUrl} from "./lh-114057c3-bakery-complete-order.js?v=43bc451967c5";
export function curatePhotographs(product) {
  const curated=window.BakeryCuratedMedia?.[product.handle]?.images;
  if(curated?.length)return curated.map(photo=>({src:window.BakeryMedia?.url(photo.u,1200)||photo.u,label:photo.label,dimensions:[photo.w,photo.h]}));
  const seen = new Set();
  let photos = (product.images || []).flatMap(image => {
    try {
      const source = catalogueImageUrl(image.src);
      if(!source)return [];
      const url = new URL(source);
      if (seen.has(url.href)) return [];
      seen.add(url.href);
      const name = url.pathname.split('/').pop();
      const label = name.includes('extra-raffaello') ? 'Fotografia de apresentação'
        : name.includes('corte-original') ? 'O corte'
        : name.includes('detalhe-original') ? 'O detalhe'
        : name.includes('caixa-original') || name.includes('tres-sabores') ? 'A caixa'
        : 'Fotografia original';
      const dimensions = [image.width, image.height].every(n => Number.isSafeInteger(n) && n > 0) ? [image.width, image.height] : null;
      return [{src: source, label, dimensions}];
    } catch { return []; }
  });
  if (product.handle === 'flor-citrica') photos = [
    {src:new URL("./lh-40e90721-flor-21-original.jpeg?width=1200",import.meta.url).href,label:'O bolo',dimensions:[2966,4030]},
    {src:new URL("./lh-36675be4-flor-detail-original.jpeg?width=1200",import.meta.url).href,label:'Flores e cobertura',dimensions:[3024,4032]},
    {src:new URL("./lh-b04f1b7c-flor-box-original.jpeg?width=1200",import.meta.url).href,label:'Na caixa',dimensions:[3024,4032]}
  ];
  if (product.handle === 'argola-dourada') photos.sort((a,b) => Number(b.src.includes('tres-sabores')) - Number(a.src.includes('tres-sabores')));
  return photos;
}
